import { render, staticRenderFns } from "./Reevaluation.vue?vue&type=template&id=abb9ecb8&lang=pug"
import script from "./Reevaluation.vue?vue&type=script&lang=ts"
export * from "./Reevaluation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports